var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.wrapperClass},[_c('v-avatar',_vm._g({class:this.avatarClass,attrs:{"username":this.username,"initials":this.initials,"background-color":this.backgroundColor,"color":this.color,"custom-style":this.customStyle,"inline":this.inline,"size":this.size,"src":this.src,"rounded":this.rounded,"lighten":this.lighten}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }